import React from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import Context from "../../../Context";
import Blocker from "../../Misc/Blocker";
import DefaultNotFound from "../../Misc/DefaultNotFound";
import DtPicker from "../../Misc/DtPicker";
import ElementPicker from "../../Misc/ElementPicker";
import SuperSelect from "../../Misc/SuperSelect";

export default class ElementEdit extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      item: {},
      notFound: false,
      pending: false,
      specification: {},
      ship: {},
      elements: {},
      specTree: {},
      elementPickShow: false,
    };
  }

  componentDidMount() {
    this.loadReferences().then(() => this.load());
  }

  componentDidUpdate(prevProps) {
    if (prevProps.elementId !== this.props.elementId) {
      this.load();
    }
  }

  onChange = (id, value) => {
    this.setState((state) => {
      let { item } = state;
      item[id] = value;
      return { item };
    });
  };

  loadReferences = async () => {
    this.setState({ pending: true });

    const { specId, shipId } = this.props;

    let specification = await this.context.api.q("/specification/get", {
      id: specId && specId !== "any" ? specId : this.context.api.nullUuid,
    });
    let ship = await this.context.api.q("/ship/get", {
      id: shipId && shipId !== "any" ? shipId : this.context.api.nullUuid,
    });
    let specTree = await this.context.api.qoo(
      `/specification/tree`,
      {
        ship: shipId && shipId !== "any" ? shipId : this.context.api.nullUuid,
        filter: { visible: true, statetypecode: "enabled" },
      },
      undefined,
      undefined,
      undefined,
      "node",
      "sequence"
    );

    this.setState({
      pending: false,
      specification,
      ship,
      specTree,
    });
  };

  getElementLabel = (id) => {
    const { elements } = this.state;
    if (elements[id]) {
      return `${elements[id].label} ${elements[id].modelname}` || "";
    }
    return "";
  };
  onElementPickClose = () => {
    this.setState({ elementPickShow: false });
  };
  onElementPickOpen = () => {
    this.setState({ elementPickShow: true });
  };
  onElementPick = (elem) => {
    this.onChange("parent", elem.id);
  };
  onElementPickClear = () => {
    this.onChange("parent", this.context.api.nullUuid);
  };

  load = async () => {
    this.setState({ pending: true });
    let itemQuery = {};

    let searchParams = new URLSearchParams(
      this.props.location.search.substr(1)
    );
    let parent = searchParams.get("parent");
    let clone = searchParams.get("clone");
    let cloneItem = {};

    if (clone) {
      cloneItem = await this.context.api.q("/element/get", {
        id: clone,
      });
    }

    if (this.props.elementId !== "add") {
      itemQuery = await this.context.api.q("/element/get", {
        id: this.props.elementId,
      });
    } else {
      if (cloneItem?.id) {
        itemQuery = {
          ...cloneItem,
          id: "add",
        };
      } else {
        itemQuery = {
          id: "add",
          specification: this.props.specId,
          parent: parent || null,
          ship:
            this.props.shipId !== "any"
              ? this.props.shipId
              : this.context.api.nullUuid,
        };
      }
    }
    let elements = await this.context.api.qo("/element/list", { reclimit: 0 });

    this.setState({
      pending: false,
      elements,
      item: itemQuery || {},
      notFound: itemQuery === false,
    });
  };

  save = async () => {
    const { item } = this.state;

    this.setState({ pending: true });

    if (item.specification === "any") {
      item.specification = null;
    }

    let result = await this.context.api.q("/element/set", {
      id: item.id === "add" ? null : item.id,
      label: item.label || null,
      ship: this.props.shipId,
      count: item.count,
      specification: item.specification,
      model: item.model,
      identity: item.identity,
      critical: item.critical,
      operating: item.operating,
      parent: item.parent || null,
      overhaul: item.overhaul || this.context.api.minDate,
    });
    if (result !== false) {
      this.context.toast("Изменения сохранены", "success");

      if (this.props.onAfterSave) {
        this.props.onAfterSave(item);
      }
      this.context.redirect(
        `/element/${this.props.shipId}/${this.props.specId}/${result.id}/`
      );
    } else {
      this.context.toast("Не удалось сохранить изменения", "error");
      this.setState({ pending: false });
    }
  };

  render() {
    const { pending, item, notFound } = this.state;
    const { shipId, specId, elementId } = this.props;
    return (
      <>
        <ElementPicker
          onElementPick={this.onElementPick}
          onClose={this.onElementPickClose}
          show={this.state.elementPickShow}
          shipId={shipId}
          specId={specId}
        />
        <Blocker hAuto spinnerFixed on={pending}>
          {notFound && <DefaultNotFound />}
          {item.id && (
            <>
              <div className="pb-3"></div>
              <h5 className="mb-5">
                {item.id === "add" ? (
                  <>Добавление оборудования</>
                ) : (
                  <>Редактирование оборудования</>
                )}
              </h5>

              <div className="alert alert-light mb-5">
                <span className="mr-2 text-muted">Судно:</span>
                {this.state.ship.name}
              </div>

              <div className="form-group">
                <label>Наименование</label>
                <input
                  id="label"
                  value={item.label || ""}
                  onChange={(e) => this.onChange("label", e.target.value)}
                  type="text"
                  className="form-control"
                />
              </div>

              <div className="form-group">
                <label>Спецификация</label>
                <select
                  id="specification"
                  value={item.specification || ""}
                  onChange={(e) => this.onChange(e.target.id, e.target.value)}
                  className="form-control"
                >
                  {item.id === "add" && <option value=""></option>}
                  {Object.entries(this.state.specTree).map(([id, item]) => (
                    <option value={item.id} key={id}>
                      {" . . ".repeat(item.level)} {item.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>Является частью оборудования</label>
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    value={this.getElementLabel(item.parent)}
                    onDoubleClick={() => this.onElementPickOpen()}
                    readOnly
                  />
                  <div className="input-group-append">
                    <button
                      title="Очистить"
                      className="btn btn-icon border"
                      type="button"
                      onClick={() => this.onElementPickClear()}
                    >
                      <i className="fa icon-md text-muted fa-times"></i>
                    </button>
                    <button
                      title="Выбрать"
                      className="btn btn-icon border"
                      type="button"
                      onClick={() => this.onElementPickOpen()}
                    >
                      <i className="fa icon-md text-muted fa-navicon"></i>
                    </button>
                  </div>
                </div>
              </div>

              <div className="form-group mt-3">
                <label>ЗИП</label>
                <SuperSelect
                  add
                  async
                  searchByCode
                  reclimit={50}
                  defaultValue={item.model}
                  onChange={(value) => this.onChange("model", value)}
                  essence="model"
                  placeholder="Выберите ЗИП..."
                  nameField="name"
                  idField="id"
                />
              </div>
              <div className="form-group">
                <label>Количество</label>
                <input
                  id="count"
                  value={item.count || ""}
                  onChange={(e) => this.onChange("count", e.target.value)}
                  type="number"
                  className="form-control"
                />
              </div>

              <div className="form-group">
                <label>Заводской номер</label>
                <input
                  id="identity"
                  value={item.identity || ""}
                  onChange={(e) => this.onChange("identity", e.target.value)}
                  type="text"
                  className="form-control"
                />
              </div>
              <div className="form-group">
                <label>Дата последнего кап. ремонта:</label>
                <DtPicker
                  isClearable
                  onChange={(v) => this.onChange("overhaul", v)}
                  value={item.overhaul}
                />
              </div>
              <div className="form-group mt-3">
                <label className="checkbox">
                  <input
                    type="checkbox"
                    id="critical"
                    onChange={(e) =>
                      this.onChange("critical", e.target.checked)
                    }
                    checked={this.state.item.critical}
                  />
                  <span className="mr-2"></span>
                  Критическое оборудование
                </label>
              </div>
              <div className="form-group mt-3">
                <label className="checkbox">
                  <input
                    type="checkbox"
                    id="operating"
                    onChange={(e) =>
                      this.onChange("operating", e.target.checked)
                    }
                    checked={this.state.item.operating}
                  />
                  <span className="mr-2"></span>
                  Учитывать наработку
                </label>
              </div>
              <div className="mb-4 py-2 border-bottom"></div>
              <div className="d-flex justify-content-between">
                <div>
                  <button onClick={this.save} className="btn btn-primary">
                    Сохранить
                  </button>
                  {elementId !== "add" && (
                    <Link
                      to={`/element/${shipId}/${specId}/${elementId}/`}
                      className="btn btn-light  ml-2"
                    >
                      Отмена
                    </Link>
                  )}
                </div>
                <div>
                  {this.props.manageModel && (
                    <Link
                      to="/model/"
                      title="Настройка ЗИП"
                      className="btn btn-light btn-icon  ml-2"
                    >
                      <i className="fa fa-cogs"></i>
                    </Link>
                  )}
                </div>
              </div>
            </>
          )}
        </Blocker>
      </>
    );
  }
}
